import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";

import { Typography, Breadcrumb, Input, Button, message, Row } from "antd";
import { Editor } from "@tinymce/tinymce-react";

import Loader from "components/Loader/Loader";

import {
  createAppVersionApi,
  fetchAppVersionDetailsApi,
  updateAppVersionApi,
} from "utils/apiService";

const { Text } = Typography;

const VersionEditor = ({ create, ...props }) => {
  const [loading, setLoading] = useState(true);
  const [versionDetails, setVersionDetails] = useState({
    version: null,
  });
  const editorRef = useRef();

  const { versionID } = useParams();

  useEffect(() => {
    !create &&
      fetchAppVersionDetailsApi({
        requestData: {
          uuid: versionID,
        },
        res200Callback: (res) => {
          setVersionDetails({ ...res.data });
        },
        resErrorCallback: () => {
          props.history.go(-1);
        },
      });

    loading && setLoading(false);
  }, []);

  return loading ? (
    <Row
      type="flex"
      align="middle"
      justify="center"
      style={{ marginTop: "200px" }}
    >
      <Loader />
    </Row>
  ) : (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div style={{ display: "flex", flexDirection: "column", width: "544px" }}>
        <Text
          style={{
            color: "#181818",
            /*fontFamily: "Gotham",*/ fontStyle: "normal",
            fontWeight: "bold",
            fontSize: "24px",
            lineHeight: "39px",
          }}
        >
          {`${!!create ? "Add" : "Edit"} Release Notes`}
        </Text>
        <Breadcrumb
          style={{ margin: "12px 0" }}
          separator={<span style={{ color: "#747474" }}>{"<"}</span>}
        >
          <Breadcrumb.Item
            style={{
              /*fontFamily: "Gotham",*/ fontStyle: "normal",
              fontWeight: "normal",
              fontSize: "14px",
              lineHeight: "22px",
              color: "#747474",
            }}
          >
            <Link to={"/developer-dash/whats-new-app"}>What’s new | App</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item
            style={{
              /*fontFamily: "Gotham",*/ fontStyle: "normal",
              fontWeight: "normal",
              fontSize: "14px",
              lineHeight: "22px",
              color: "#464646",
            }}
          >
            {!!create ? "Add Release Notes" : `${versionDetails.version}`}
          </Breadcrumb.Item>
        </Breadcrumb>
        <div
          style={{
            background: "#FFFFFF",
            border: "1px solid #F2F2F2",
            boxSizing: "border-box",
            boxShadow: "0px 5px 10px rgba(24, 24, 24, 0.05)",
            display: "flex",
            flexDirection: "column",
            borderRadius: 5,
            padding: 24,
          }}
        >
          <Text
            style={{
              fontStyle: "normal",
              fontWeight: "bold",
              fontSize: "14px",
              lineHeight: "22px",
              color: "#181818",
            }}
          >
            Version Number
          </Text>
          <Input
            style={{
              backgroundColor: "#FFFFFF",
              border: "1px solid #D9D9D9",
              borderRadius: "4px",
              marginTop: "8px",
            }}
            value={versionDetails.version}
            onChange={(e) => {
              setVersionDetails({ ...versionDetails, version: e.target.value });
            }}
            placeholder={"Enter Version Number"}
            maxLength={65}
          />
          <Text
            style={{
              fontStyle: "normal",
              fontWeight: "bold",
              fontSize: "14px",
              lineHeight: "22px",
              color: "#181818",
              margin: "32px 0 8px",
            }}
          >
            Description
          </Text>
          <Editor
            apiKey='5uv78fphj9sndnha6xh30qanrvek9n49j9z9bcykz2ki9i06'
            style={{
              border: "1px solid #D9D9D9",
              borderRadius: "4px",
            }}
            onInit={(evt, editor) => (editorRef.current = editor)}
            initialValue={versionDetails?.description}
            init={{
              height: 500,
              menubar: true,
              image_uploadtab: true,
              plugins: [
                "advlist autolink lists link image charmap print preview anchor",
                "searchreplace visualblocks code fullscreen",
                "insertdatetime media table paste code help wordcount",
              ],
              toolbar:
                "undo redo | formatselect  | bold italic | alignleft aligncenter " +
                "alignright alignjustify | bullist numlist outdent indent | " +
                "removeformat | help",
              content_style: "body { font-family: Helvetica }",
            }}
          />
          <div style={{ marginTop: "32px", textAlign: "right" }}>
            <Button
              size="large"
              style={{
                height: "40px",
                boxShadow: "none",
                borderRadius: "5px",
                border: "1px solid #D9D9D9",
                backgroundColor: "#FFFFFF",
                color: "#181818",
                marginRight: "16px",
              }}
              onClick={() => props.history.go(-1)}
            >
              Cancel
            </Button>
            <Button
              size="large"
              style={{
                height: "40px",
                borderRadius: "5px",
                border: "none",
                backgroundColor: "#fec708",
                color: "#FFFFFF",
              }}
              onClick={() => {
                !!create
                  ? createAppVersionApi({
                      requestData: {
                        ...versionDetails,
                        description: editorRef.current.getContent(),
                      },
                      res200Callback: () => {
                        message.success(
                          "App Version Release Notes Created Successfully."
                        );
                        props.history.go(-1);
                      },
                    })
                    : updateAppVersionApi({
                      requestData: {
                        ...versionDetails,
                        description: editorRef.current.getContent(),
                        uuid: versionID,
                      },
                      res200Callback: () => {
                        message.success(
                          "App Version Release Notes Updated Successfully."
                          );
                          props.history.go(-1);
                      },
                    });
              }}
            >
              {!!create ? "Create Note" : "Update Now"}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VersionEditor;
